import { render, staticRenderFns } from "./FormatTableSelector.vue?vue&type=template&id=3893fc1c&scoped=true&"
import script from "./FormatTableSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatTableSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatTableSelector.vue?vue&type=style&index=0&id=3893fc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3893fc1c",
  null
  
)

export default component.exports